export const GET_ORDER_DATA_LOADING = "GET_ORDER_DATA_LOADING";
export const GET_ORDER_DATA_SUCCESS = "GET_ORDER_DATA_SUCCESS";
export const GET_ORDER_DATA_ERROR = "GET_ORDER_DATA_ERROR";